import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { AddAttendanceRequest } from "./AddAttendanceRequest";
import { UpdateAttendanceRequest } from "./UpdateAttendanceRequest";
import { AttendanceCheckRequest } from "./AttendanceCheckRequest";

@Injectable()
export class DataService_Attendance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadAttendance(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "Attendance/AttendanceInfoGetList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStatusList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Attendance/LoadStatusList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadExcuses(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "Attendance/LoadExcuses?SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStudentID(PersonID) {
		var postResult$ = new Subject();
		var url = "Attendance/LoadStudentID?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CheckSuspended(PersonID, Date) {
		var postResult$ = new Subject();
		var url = "Attendance/CheckSuspended?PersonID=" + PersonID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetReleaseSchedule(PersonID, Date) {
		var postResult$ = new Subject();
		var url = "Attendance/PersonGetReleaseSchedule?PersonID=" + PersonID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceExists(PersonID, Date) {
		var postResult$ = new Subject();
		var url = "Attendance/AttendanceExists?PersonID=" + PersonID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddAttendance(parms: AddAttendanceRequest) {
		var postResult$ = new Subject();
		var url = "Attendance/AddAttendance";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateAttendance(parms: UpdateAttendanceRequest) {
		var postResult$ = new Subject();
		var url = "Attendance/UpdateAttendance";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadAttendanceHistory(PersonID, EntryDate) {
		var postResult$ = new Subject();
		var url = "Attendance/LoadAttendanceHistory?PersonID=" + PersonID + "&EntryDate=" + EntryDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadTimeScan(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "Attendance/LoadTimeScan?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceStatsInfoGetList(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "Attendance/AttendanceStatsInfoGetList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceModifyCheck(parms: AttendanceCheckRequest) {
		var postResult$ = new Subject();
		var url = "Attendance/AttendanceModifyCheck";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
